import type { FlowPlayer } from "@rivaled/shared";
import type { RouterOutputs } from "../../lib/trpc";

export type MatchData = NonNullable<RouterOutputs["match"]["get"]>;

/**
 * Structural type matching match.players[number].
 * Defined here to avoid circular imports with the trpc-derived MatchData type.
 */
export type MatchPlayer = {
  userId: string;
  username: string | null;
  avatarUrl: string | null;
  team: number;
  partyId: string | null;
  eloAtMatch: number | null;
  isHost: boolean | null;
  gameIdentity: string | null;
};

export function toFlowPlayer(p: MatchPlayer): FlowPlayer {
  return {
    userId: p.userId,
    username: p.username ?? "Unknown",
    avatarUrl: p.avatarUrl,
    displayElo: p.eloAtMatch ?? 0,
    team: p.team,
    partyId: p.partyId ?? null,
    isConnected: true,
    isHost: p.isHost ?? false,
    lastSeenAt: Date.now(),
  };
}

export function formatModePill(teamCount: number, teamSize: number): string {
  if (teamSize === 1) return `${teamCount} Player FFA`;
  if (teamCount === 2) return `${teamSize}v${teamSize}`;
  if (teamCount <= 4) return Array(teamCount).fill(`${teamSize}`).join("v");
  return `${teamSize}v${teamSize} ×${teamCount}`;
}
